import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

// Basic RFC-lite email regex — server side is the authority.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function WaitlistForm() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return; // block rapid double-clicks
    const trimmed = email.trim();
    if (!trimmed) {
      toast.error("Please enter your email address.");
      return;
    }
    if (!EMAIL_RE.test(trimmed)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await api.post("/waitlist", { email: trimmed });
      if (data.status === "already_subscribed") {
        toast.success("You're already on the Interstate PC launch list.");
      } else {
        toast.success("You're on the list! We'll let you know when Interstate PC launches.");
      }
      setDone(true);
      setEmail("");
    } catch (err) {
      // Never surface backend/db details to the visitor.
      toast.error("We couldn't add you right now. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="border border-yellow-500/30 bg-[#0a0a0c] rounded-sm p-5 md:p-6"
         data-testid="waitlist-card">
      <div className="font-mono text-[10px] tracking-widest text-yellow-400 uppercase mb-2">
        // NOTIFY ME AT LAUNCH
      </div>
      <h3 className="font-display font-bold text-xl md:text-2xl text-white mb-1"
          data-testid="waitlist-heading">
        Get Notified When We Launch
      </h3>
      <p className="text-sm text-zinc-400 mb-4 leading-relaxed">
        Be the first to know when Interstate PC&rsquo;s online catalog and ordering go live.
      </p>
      <form onSubmit={onSubmit} className="flex flex-col sm:flex-row gap-2"
            data-testid="waitlist-form" noValidate>
        <input
          type="email"
          required
          inputMode="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email address"
          disabled={submitting}
          data-testid="waitlist-email-input"
          className="flex-1 bg-black border border-zinc-800 rounded-sm px-3 py-2.5 text-sm text-white placeholder:text-zinc-600 focus:outline-none focus:border-[#FF5C00] disabled:opacity-60"
        />
        <button
          type="submit"
          disabled={submitting}
          data-testid="waitlist-submit-btn"
          className="bg-[#FF5C00] hover:bg-[#FF7A33] disabled:bg-zinc-700 disabled:cursor-not-allowed text-black font-mono text-xs tracking-widest uppercase font-bold px-5 py-2.5 rounded-sm transition-colors">
          {submitting ? "Adding..." : done ? "Added" : "Notify Me"}
        </button>
      </form>
      <p className="text-[11px] text-zinc-500 mt-3 leading-relaxed"
         data-testid="waitlist-disclosure">
        By signing up, you agree to receive launch and store updates from Interstate PC.
        You can unsubscribe at any time.
      </p>
    </div>
  );
}
